import { useAuth } from '../../context/AuthContext';
import { useClient } from '../../context/ClientContext';
import { useLocation, Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  const { clientId , clientPath} = useClient();
  const location = useLocation();

  if (!token) {
    return <Navigate to={clientPath('/login')} state={{ volverA: location.pathname + location.search }} replace />;
  }

  return children;
};